import { Component, Mixins } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import { UserDetails } from '@/Model/model';
import commonEntry from '@/store/modules/commonEntry';
import ChangePasswordComponent from './changePasswordPopup/ChangePasswordPopup.vue';
import ChangeEmailPopup from './changeEmailPopup/ChangeEmailPopup.vue';
import UIkit from 'uikit';
import AccountSettings from '@/mixins/accountSettings.mixin';
import { getDecodedToken } from '@/services/common/httpClient';

@Component({
  components: {
    'change-password': ChangePasswordComponent,
    'change-email-popup': ChangeEmailPopup
  }
})
export default class UserProfileComponent extends Mixins(AccountSettings) {
  public edit: boolean = true;
  public phoneNumber: any = '';
  public classClose: boolean = false;
  public phoneNumberMsg: string = '';
  public emailMsg: string = '';
  public userObj: UserDetails = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    personalInvitationNote: '',
    profilePicture: {
      contentType: '',
      contentBytes: ''
    },
    firstLogin: true,
    previousUserRoleId: 0,
    selectedUserRoleId: 0,
    accountId: 0,
    programId: 0,
    siteId: 0
  };
  public hovering: boolean = false;
  public profileValidation = false;
  public emailCheck: boolean = true;
  public duplicateEmailCheck: boolean = false;
  public btnSaveSettingsDisabled = true;
  public validatedFields = APP_CONST.VALIDATE_CREATE_USER_FORM && JSON.parse(JSON.stringify(APP_CONST.VALIDATE_CREATE_USER_FORM));
  public firstNameError: boolean = false;
  public lastNameError: boolean = false;
  public firstNameErrorMessage: string = '';
  public lastNameErrorMessage: string = '';
  public isMobileView = true;
  public emailError = false;
  APP_CONST = APP_CONST;

  /* istanbul ignore next */
  get userReactiveObject() {
    return this.userObj;
  }

  /* istanbul ignore next */
  set userReactiveObject(obj: UserDetails) {
    this.userObj = obj;
  }

  /* istanbul ignore next */
  get userDetail() {
    return commonEntry.userDetail;
  }

  /* istanbul ignore next */
  get submitResponse(): object {
    return commonEntry.getSubmit;
  }

  /* istanbul ignore next */
  get userName(){
    return commonEntry.savedUserName;
  }

  /* istanbul ignore next */
  onClick() {
    this.$gtm && this.$gtm.trackEvent({
      event: null,
      category: 'My Profile Page',
      action: 'click',
      label: 'User Profile Page Click Event Activated',
      value: 5000,
      noninteraction: false,
    });
  }

  /* istanbul ignore next */
  mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }
    this.isMobile();
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.PROFILE.viewedProfile);
  }

  public resetPhoneNumberFormat(obj: any) {
    const phoneNumber = obj.phoneNumber;
    const phoneCondition = (phoneNumber)
      ? phoneNumber.replace(/[^0-9]/g, '')
      : '';
    obj.phoneNumber = (phoneNumber && phoneNumber.charAt(0) == '0')
      ? ''
      : (phoneCondition);
  }

  public checkEmailField(evnet: any) {
    /* istanbul ignore else */
    if (this.userReactiveObject.email.length) {
      this.emailMsg = '';
      this.emailCheck = true;
    }
    const res = !this.validatedFields.firstName.alphaCharError
            && !this.validatedFields.lastName.alphaCharError && this.emailCheck;
    /* istanbul ignore else */
    if (res) {
      this.profileValidation = false;
    }
    this.duplicateEmailCheck = false;
  }

  validateEmail(mail: string) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(mail);
  }

  validateEmailByRole(){
    let emailCheck = false;
    /* istanbul ignore else */
    if(this.validateEmail(this.userReactiveObject.email)){
      emailCheck = true;
    }
    return emailCheck;
  }

  public saveUpdatedData() {
    /* istanbul ignore else */
    if ((!this.validatedFields.lastName.alphaCharError && !this.validatedFields.firstName.alphaCharError)) {
      this.emailCheck = this.validateEmailByRole();
      /* istanbul ignore else */
      if (this.userReactiveObject.firstName === '' || this.userReactiveObject.lastName === '' || this.userReactiveObject.email === '') {
        this.profileValidation = true;
        this.duplicateEmailCheck = false;
        return false;
      }
      /* istanbul ignore else */
      if (this.emailCheck) {
        const obj = { ...this.userObj };
        this.resetPhoneNumberFormat(obj);
        const userValues = Object.values(obj);
        userValues.splice(10, 2);
        const checkLength = userValues.every((item) => item !== null || item !== '');
        /* istanbul ignore else */
        if (checkLength) {
          const updateProfile = 'updateUser';
          commonEntry.updateUserDetails({ obj, updateProfile }).then((data: any) => {
            this.actionAfterSaveUpdateData(data, obj);
            APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.PROFILE.editedProfile);
          }).catch((err) => {
            console.log('in error section', err);
          });
        }
      }
      else {
        this.emailMsg = 'Email is invalid';
      }
    }
  }

  actionAfterSaveUpdateData(data: any, obj: any) {
    this.profileValidation = false;
    if (data && data.status === APP_CONST.RESPONSE_200) {
      commonEntry.updateUserfirstName(obj);
      this.btnSaveSettingsDisabled = true;
      this.edit = true;
      this.duplicateEmailCheck = false;
      this.emailMsg = '';
      this.phoneNumberMsg = '';
      UIkit.notification.closeAll();
      UIkit.notification({
        message: data.data.value,
        status: 'primary',
        pos: 'top-center',
        timeout: 5000
      });
    }
    else if (data && data.status === APP_CONST.RESPONSE_400) {
      /* istanbul ignore else */
      if (data.data.errors && data.data.errors.hasOwnProperty('firstName')) {
        this.firstNameError = true;
        this.firstNameErrorMessage = data.data.errors.firstName[0];
      }
      /* istanbul ignore else */
      if (data.data.errors && data.data.errors.hasOwnProperty('lastName')) {
        this.lastNameError = true;
        this.lastNameErrorMessage = data.data.errors.lastName[0];
      }
      /* istanbul ignore else */
      if (data.data.name === APP_CONST.ERROR_DUPLICATE_EMAIL || data.data.name === APP_CONST.USER_ALREADY_REGISTERED) {
        this.emailMsg = '';
        this.emailCheck = false;
        this.duplicateEmailCheck = true;
        this.phoneNumberMsg = '';
      }
      else {
        this.phoneNumberMsg = data.data.errors.phoneNumber[0];
      }
    }
    else {
      /* istanbul ignore else */
      if (data && data.status === APP_CONST.RESPONSE_406) {
        this.duplicateEmailCheck = true;
      }
    }
  }

  public editMode() {
    this.edit = false;
    this.btnSaveSettingsDisabled = false;
    const obj = this.userObj;
    const phoneNumber = this.formatPhoneNumber(this.userObj.phoneNumber);
    obj.phoneNumber = phoneNumber;
    this.userObj = obj;
  }

  formatPhoneNumber(phoneNumberString: any) {
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    /* istanbul ignore else */
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    else{
      return phoneNumberString;
    }
  }

  public async beforeMount() {
    const { userId: user_id }: any = await getDecodedToken();
    /* istanbul ignore else */
    if (user_id) {
      commonEntry.fetchUserDetails(parseInt(user_id));
    }
  }

  public beforeUpdate() {
    this.userObj = commonEntry.userDetail as UserDetails;
    this.emailError = true;
  }

  public reloadPasswordInfo() {
    /* istanbul ignore else */
    if (UIkit.modal('#password-screen')) {
      UIkit.modal('#password-screen').show();
    }
  }

  public firstNameValidatinOnlyAlphabet(event: any) {
    this.firstNameError = false;
    this.firstNameErrorMessage = '';
    const key = event.key;
    const name = this.userObj.firstName;
    for (let i = 0; i < name.length; i++) {
      const numberCheck = APP_UTILITIES.hasOnlyAlphabetDotSpace(name);
      /* istanbul ignore else */
      if (!numberCheck) {
        this.validatedFields.firstName.alphaCharError = true;
        return;
      }
      this.validatedFields.firstName.alphaCharError = false;
    }
    /* istanbul ignore else */
    if (key == 'Backspace') {
      this.validatedFields.firstName.alphaCharError = false;
    }
    else if (!this.validatedFields.firstName.alphaCharError
            && !this.validatedFields.lastName.alphaCharError && this.emailCheck) {
      this.profileValidation = false;
    }
  }

  public lastNameValidatinOnlyAlphabet(event: any) {
    this.lastNameError = false;
    this.lastNameErrorMessage = '';
    const key = event.key;
    const name = this.userObj.lastName;
    for (let i = 0; i < name.length; i++) {
      const numberCheck = APP_UTILITIES.hasOnlyAlphabetDotSpace(name);
      /* istanbul ignore else */
      if (!numberCheck) {
        this.validatedFields.lastName.alphaCharError = true;

        return;
      }
      this.validatedFields.lastName.alphaCharError = false;
    }
    /* istanbul ignore else */
    if (key == 'Backspace') {
      this.validatedFields.lastName.alphaCharError = false;
    }
    else if (!this.validatedFields.firstName.alphaCharError
            && !this.validatedFields.lastName.alphaCharError && this.emailCheck) {
      this.profileValidation = false;
    }
  }

  public oldPasswordError() {
    commonEntry.submitClear();
  }

  isMobile() {
    this.isMobileView = APP_UTILITIES.isMobile();
  }

  /* istanbul ignore next*/
  destroyed() {
    /* istanbul ignore else*/
    if(UIkit.modal('#password-screen')){
      UIkit.modal('#password-screen').$destroy(true);
    }
  }

  public openChangeEmailPopup() {
    if (UIkit && UIkit.modal('#email-screen')) {
      UIkit.modal('#email-screen').show();
    }
  }
}